"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * © 2019 Liferay, Inc. <https://liferay.com>
 *
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayModalBody = function ClayModalBody(_ref) {
  var children = _ref.children,
      url = _ref.url;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('modal-body', {
      'modal-body-iframe': url
    })
  }, url ? _react.default.createElement("iframe", {
    src: url,
    title: url
  }) : children);
};

var _default = ClayModalBody;
exports.default = _default;